import { ALL_CONSTANTS } from "../constants/displayConstants";
import NLI_CONSTANTS from "../Products/nli/data/urlPathConstants.js";

export default function getServiceNameFromPath(pathName) {
  let serviceName = "";

  switch (pathName) {
    case ALL_CONSTANTS.PROFILE_PATH:
      serviceName = ALL_CONSTANTS.PROFILE_URL_END;
      break;
    case ALL_CONSTANTS.PROFILEVERIFY_PATH:
      serviceName = ALL_CONSTANTS.PROFILE_URL_END;
      break;
    case ALL_CONSTANTS.ACCOUNT_PATH:
      serviceName = ALL_CONSTANTS.ACCOUNT_URL_END;
      break;
    case ALL_CONSTANTS.ACCOUNTVERIFY_PATH:
      serviceName = ALL_CONSTANTS.ACCOUNT_URL_END;
      break;
    case ALL_CONSTANTS.CREDIT_CARD_PATH:
      serviceName = ALL_CONSTANTS.CREDIT_CARD_URL_END;
      break;
    case ALL_CONSTANTS.CREDITVERIFY_CARD_PATH:
      serviceName = ALL_CONSTANTS.CREDIT_CARD_URL_END;
      break;
    case ALL_CONSTANTS.LOAN_PATH:
      serviceName = ALL_CONSTANTS.LOAN_URL_END;
      break;
    case ALL_CONSTANTS.LOANVERIFY_PATH:
      serviceName = ALL_CONSTANTS.LOAN_URL_END;
      break;
    case ALL_CONSTANTS.DEPOSITS_PATH:
      serviceName = ALL_CONSTANTS.DEPOSITS_URL_END;
      break;
    case ALL_CONSTANTS.DEPOSITSVERIFY_PATH:
      serviceName = ALL_CONSTANTS.DEPOSITS_URL_END;
      break;
    case ALL_CONSTANTS.INVESTMENT_PRODUCT_PATH:
      serviceName = ALL_CONSTANTS.INVESTMENT_PRODUCT_URL_END;
      break;
    case ALL_CONSTANTS.INVESTMENT_PRODUCTVERIFY_PATH:
      serviceName = ALL_CONSTANTS.INVESTMENT_PRODUCT_URL_END;
      break;
    case ALL_CONSTANTS.FOREX_PATH:
      serviceName = ALL_CONSTANTS.FOREX_URL_END;
      break;
    case ALL_CONSTANTS.FOREX_PATHVERIFY:
      serviceName = ALL_CONSTANTS.FOREX_URL_END;
      break;
    case ALL_CONSTANTS.DUE_PATH:
      serviceName = ALL_CONSTANTS.DUE_URL_END;
      break;
    case ALL_CONSTANTS.DUE_VERIFICATION_PATH:
      serviceName = ALL_CONSTANTS.DUE_URL_END;
      break;
    case ALL_CONSTANTS.ATMDEBIT_PATH:
      serviceName = ALL_CONSTANTS.DEBIT_URL_END;
      break;
    case ALL_CONSTANTS.OTHERURL_PATH:
      serviceName = ALL_CONSTANTS.OTHERURL_END;
      break;

    case "/servicing/due/overdueScreen":
      serviceName = "/due";
      break;
    case "/servicing/due/OverdueDetails":
      serviceName = "/due";
      break;
    case "/servicing/due/OverduePayment":
      serviceName = "/due";
      break;
    case "/servicing/due/WhatsappConsent":
      serviceName = "/due";
      break;
    case "/servicing/due/quickPay":
      serviceName = "/due";
      break;
    case "/servicing/due/QuickPayStatus":
      serviceName = "/due";
      break;

    case "/servicing/due/overduePayStatus":
      serviceName = "/due";
      break;

    case "/servicing/due/settlementPayStatus":
      serviceName = "/due";
      break;
    case "/servicing/due/transactionSuccess":
      serviceName = "/due";
      break;
    case "/servicing/due/transactionError":
      serviceName = "/due";
      break;
    case "/agent-login":
      serviceName = "/servicing/login";
      break;
    case "/login/":
      serviceName = "/servicing/login";
      break;
    case NLI_CONSTANTS.NLI_GRIEVANCE_FORM_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_BLUEDART_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_SR_REQUEST_FORM_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_COMPLIMENTS_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_EMV_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_TRACK_SHIPMENT_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_KYC_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_GRIEVANCE_TWO_FORM_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_GRIEVANCE_FORM_THREE_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_SUBMIT_GRIEVANCE_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_FOREX_REQ_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_DETAILS_RESPONSE_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_PROPERTY_SEARCH_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_NSE_TICKER_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_GDPR_HOME_PATH:
      serviceName = NLI_CONSTANTS.IMOBILE_URL_END;
      break;
    case NLI_CONSTANTS.NLI_GDPR_CHECK_CUSTOMER_PATH:
      serviceName = NLI_CONSTANTS.IMOBILE_URL_END;
      break;
    case NLI_CONSTANTS.NLI_GDPR_PATH:
      serviceName = NLI_CONSTANTS.IMOBILE_URL_END;
      break;
    case NLI_CONSTANTS.NLI_FEEDBACK_NPS_FORM_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_FEEDBACK_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_FEEDBACK_EXPERIENCE_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_FOREX_INSTA_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_SR_CONFIRMATION_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_LOAN_TRACKER_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_UNCLAIMED_DEPOSIT_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_UNCLAIMED_DEPOSIT_ACCOUNT_DETAIL_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_SHARE_HOLDER_FORM_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_INVESTOR_UPLOAD_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_EASY_POS_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_SUBMITTED_RESPONSE_PAGE_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_SUBMIT_POS_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_UNCLAIMED_DIVIDENTS_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_UNCLAIMED_DIVIDENTS_LIST_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_TRACK_MY_LOAN_LOGIN_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_CAR_LOAN_DASHBOARD_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_CREDITCARD_EMI_CHECK_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_LOAN_EMI_CHECK_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_PREPAID_FORM_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_PREPAID_HOME_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_PREPAID_KYC_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_PREPAID_APPLICATION_PROCESS_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_PREPAID_EMAIL_VERIFICATION_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_PREPAID_DASHBOARD_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_CASH_DEPOSIT_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_SHOW_FUND_TRANSFER_SLIP_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_NRI_FORM_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_AURA_LOGIN_FORM_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_AURA_ACCOUNT_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_AURA_SUBMIT_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_OFFER_PORTAL_LOGIN_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_GRID_CARD_LOGIN:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_GRID_CARD_AUTHENTICATION:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_ENACH_FORM:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_DONATION_FORM_LOGIN:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_PREVIEW_DONATION_FORM:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_CASH_KARO_LOGIN:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_ERROR_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_SUCCESS_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    case NLI_CONSTANTS.NLI_DUPLICATE_PATH:
      serviceName = NLI_CONSTANTS.NLI_URL_END;
      break;
    default:
      serviceName = "";
      break;
  }

  return serviceName;
}
